import HTTPService from '../HTTPService'

class Operators {
  getAll (companySlug, hideCompanyCreator = false) {
    return HTTPService.get(`company/${companySlug}/operator?hide_company_creator=${hideCompanyCreator}`)
  }

  addOne (companySlug, payload) {
    return HTTPService.post(`company/${companySlug}/operator`, {
      name: payload.name,
      email: payload.email,
      password: payload.password,
      profile_image_key: payload.profile_image_key
    })
  }

  getOne (companySlug, operatorEmail) {
    return HTTPService.get(`company/${companySlug}/operator/${operatorEmail}`)
  }

  updateOne (companySlug, operatorEmail, payload) {
    return HTTPService.put(`company/${companySlug}/operator/${operatorEmail}`, {
      name: payload.name,
      password: payload.password,
      profile_image_key: payload.profile_image_key
    })
  }

  deleteOne (companySlug, operatorEmail) {
    return HTTPService.delete(`company/${companySlug}/operator/${operatorEmail}`)
  }
}

export default new Operators()
